import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center shorteval-wrapper w-100" }
const _hoisted_5 = ["aria-hidden", "for"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "icon icon-tick",
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "10",
  viewBox: "0 0 15 10",
  fill: "none"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.52468 9.58534C4.52819 9.58895 4.53174 9.59255 4.53531 9.59612C4.65814 9.71895 4.80498 9.80315 4.96072 9.84871C5.30018 9.94812 5.682 9.86394 5.94975 9.59619C5.95457 9.59137 5.95933 9.58651 5.96403 9.58162L13.7277 1.81795C14.1182 1.42742 14.1182 0.794257 13.7277 0.403733C13.3372 0.0132088 12.704 0.0132088 12.3135 0.403733L5.2425 7.47472L1.70711 3.93933C1.31658 3.54881 0.683417 3.54881 0.292893 3.93933C-0.0976311 4.32986 -0.0976311 4.96302 0.292893 5.35355L4.52468 9.58534Z",
  fill: "#44BE0A"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_component = _resolveComponent("radio-component")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_WarnTriangleFilled = _resolveComponent("WarnTriangleFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_ctx.options.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['shorteval-select-component mb-5', _ctx.showElement ? '' : 'd-none']),
        id: `element-${_ctx.name}`
      }, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              innerHTML: _ctx.title,
              class: "mb-3 d-block"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.frequentItems)
          ? (_openBlock(), _createBlock(_component_radio_component, {
              key: 1,
              title: _ctx.radioTitle,
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
              options: _ctx.brands,
              value: _ctx.value.toString(),
              name: _ctx.name,
              gap: 'me-3',
              id: `${_ctx.id}-radio`,
              "div-class": _ctx.radioDivClass,
              "is-component-in-component": true,
              onChange: _ctx.updateValue
            }, null, 8, ["title", "modelValue", "options", "value", "name", "id", "div-class", "onChange"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", {
              "aria-hidden": !_ctx.canShowLabel,
              for: _ctx.id,
              class: _normalizeClass(['el-form-item__label', _ctx.isFloatingLabel ? 'floating-label' : '', _ctx.canShowLabel ? '' : 'd-none'])
            }, _toDisplayString(_ctx.placeholder), 11, _hoisted_5),
            (_ctx.options.length)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: _ctx.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
                  filterable: "",
                  clearable: false,
                  name: _ctx.name,
                  id: _ctx.id,
                  placement: 'bottom-start',
                  placeholder: (_ctx.title && !_ctx.frequentItems) ? _ctx.placeholder : ' ',
                  class: _normalizeClass([
            _ctx.showError ? 'text-danger errorElement' : '',
            _ctx.icons.clearIcon && _ctx.clearable && _ctx.isTouched ? 'me-1 me-lg-3' : 'me-1 me-lg-3',
            _ctx.classInput,
            { 'is-disabled' : _ctx.disabled}
          ]),
                  disabled: _ctx.disabled,
                  onChange: _ctx.updateValue,
                  onClear: _ctx.clear,
                  onClick: _ctx.setFloatingLabel,
                  onFocus: _ctx.setFloatingLabel,
                  onBlur: _ctx.resetFloatingLabel
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (group) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (group && group.options && group.options.length > 0)
                          ? (_openBlock(), _createBlock(_component_el_option_group, {
                              key: group.value,
                              label: group.label
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: _ctx.replaceBrWithComma(item.label),
                                    value: item.value,
                                    class: _normalizeClass(_ctx.getOptionClass(item.label))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: item.label
                                      }, null, 8, _hoisted_6)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value", "class"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue", "name", "id", "placeholder", "class", "disabled", "onChange", "onClear", "onClick", "onFocus", "onBlur"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.icons.clearIcon && _ctx.clearable && _ctx.isTouched)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args))),
                src: _ctx.icons.clearIcon,
                alt: 'Clear icon',
                class: "el-select-clear-icon img-fluid"
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.isTouched || _ctx.showError)
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "ms-1",
                style: {"vertical-align":"middle"},
                size: 20,
                color: `${_ctx.showError ? '#DE0D26' : '#44BE0A'}`
              }, {
                default: _withCtx(() => [
                  (_ctx.isValid)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (!_ctx.isValid || _ctx.showError)
                    ? (_openBlock(), _createBlock(_component_WarnTriangleFilled, { key: 1 }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
              _createElementVNode("small", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}